class CBlockType {
  static COMMAND = "COMMAND";

  static STARTER_HAT = "STARTER_HAT";

  static OUTPUT = "OUTPUT";
}

module.exports = CBlockType;
